export const FLOW_OBJECT_TYPE_LOCK = 'FLOW_OBJECT_TYPE_LOCK';
export const WORKFLOW_LIMITS_LOCK = 'WORKFLOW_LIMITS_LOCK';
export const WORKFLOW_LIMITS_ENTERPRISE_LOCK = 'WORKFLOW_LIMITS_ENTERPRISE_LOCK';
export const WORKFLOW_ACCESS_DENIED_LOCK = 'WORKFLOW_ACCESS_DENIED_LOCK';
export const WORKFLOW_READ_ONLY_LOCK = 'WORKFLOW_READ_ONLY_LOCK';
export const DISABLED_LOCK_TYPES = [WORKFLOW_LIMITS_ENTERPRISE_LOCK, WORKFLOW_READ_ONLY_LOCK];